var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosebig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7804 0.219594C17.6398 0.078988 17.449 0 17.2501 0C17.0513 0 16.8605 0.078988 16.7199 0.219594L9 7.93948L1.28011 0.219594C1.13946 0.078988 0.94873 0 0.749853 0C0.550977 0 0.360242 0.078988 0.219594 0.219594C0.078988 0.360242 0 0.550977 0 0.749853C0 0.94873 0.078988 1.13946 0.219594 1.28011L7.93948 9L0.219594 16.7199C0.078988 16.8605 0 17.0513 0 17.2501C0 17.449 0.078988 17.6398 0.219594 17.7804C0.360242 17.921 0.550977 18 0.749853 18C0.94873 18 1.13946 17.921 1.28011 17.7804L9 10.0605L16.7199 17.7804C16.8605 17.921 17.0513 18 17.2501 18C17.449 18 17.6398 17.921 17.7804 17.7804C17.921 17.6398 18 17.449 18 17.2501C18 17.0513 17.921 16.8605 17.7804 16.7199L10.0605 9L17.7804 1.28011C17.921 1.13946 18 0.94873 18 0.749853C18 0.550977 17.921 0.360242 17.7804 0.219594Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosebig);
export default __webpack_public_path__ + "static/media/closebig.1ab0ab44ddf2b1744c6733251e17c110.svg";
export { ForwardRef as ReactComponent };